import React from 'react';
import { Spin } from 'antd';

interface Props {
  text?: string;
}

function Index({ text = 'loading...' }: Props) {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <Spin size='large' tip={text} />
    </div>
  );
}

export default React.memo(Index);
